// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__kKJNx","productName":"Table_productName__GRe_q"};